module.exports = __webpack_public_path__ + "img/nav_welfare.c64fa413.png";